import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutDispatchEquipAlerts extends Layout {
    layoutheaderEquipAlerts: LayoutHeader;
    sourceUnitMessage: DataSource;
    tableAlerts: Table;
}
